<template lang="html">
  <div class="wrap">
    <el-date-picker
      v-model="date"
      type="datetimerange"
      range-separator="至"
      :clearable="false"
      start-placeholder="开始日期"
      end-placeholder="结束日期">
    </el-date-picker>
    <el-input v-model.trim="system" placeholder="请输入系统信息" class='user-input'></el-input>
    <el-input v-model.trim="user" placeholder="请输入用户信息" class='user-input'></el-input>
    <el-input v-model.trim="path" placeholder="请输入路由信息" class='user-input'></el-input>
    <el-button @click="fetch()" type="text" size="small">查询</el-button>
    <el-table
      class='table'
      :data="tableData"
      style="width: 100%">
      <el-table-column type="index" label="序号" width="180">
      </el-table-column>
      <el-table-column
        prop="gmt_create"
        label="日期"
        width="180">
        <template slot-scope="scope">
          <span>{{moment(scope.row.gmt_create).format('YYYY-MM-DD HH:mm:ss')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="user_identifier"
        label="姓名"
        width="180">
      </el-table-column>
      <el-table-column
        prop="system"
        label="系统"
        width="180">
      </el-table-column>
      <el-table-column
        prop="path"
        label="路由"
        width="180">
        <template slot-scope="scope">
          <div style="-webkit-box-orient: vertical;" class="over-path"> {{ scope.row.path }}</div>
        </template>
      </el-table-column>
      <el-table-column
        prop="totalTracks"
        label="操作复杂度"
        width="180">
      </el-table-column>
      <el-table-column
        label="查看操作">
         <template slot-scope="scope">
  <router-link
    :to="{ name: 'play', params: { recordKey: scope.row.record_key }}"
    target="_blank"
  >查看操作</router-link>
  <!-- <el-button @click="fetchPlay(scope.row.recordKey)" type="text" size="small">查看操作</el-button> -->
</template>
      </el-table-column>
    </el-table>
    <el-pagination
      layout="prev, pager, next"
      @current-change="handleCurrentChange"
      :current-page.sync="page"
      :page-size="20"
      :total='count'
      >
    </el-pagination>
  </div>
</template>
<script>
  import axios from 'axios';
  import qs from 'qs';
  import moment from 'moment';
  export default {
    mounted() {
      // 初始化数据
      this.fetch();
    },
    methods: {
      moment,
      handleCurrentChange(page) {
        this.fetch(page);
      },
      unique(arr) {
        let hashTable = [];
        let newArr = [];
        arr.map(item => {
          if(hashTable.indexOf(item.record_key) === -1) {
            hashTable.push(item.record_key)
            newArr.push(item);
          }
        })
        return newArr;
      },
      fetch(page) {
        if (!this.date) {
          return this.$message('请选择时间');
        }
        const query = {
          startTime: moment(new Date(this.date[0])).format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment(new Date(this.date[1])).format('YYYY-MM-DD HH:mm:ss'),
          currentPage: page || this.page,
          pageSize: 20,
          system: this.system,
          userIdentifier: this.user,
          path: this.path
        };
        return axios.get(`/behavior/queryList?${qs.stringify(query)}`).then(response => {
          const {
            total,
            list
          } = response.data.data
          this.count = total
          // gaoming@duiba.com.cn 此账号的广告详情页面的操作以及素材数据页面不做展示
          const _list = list.filter((item, index) => {
            return !(JSON.parse(JSON.parse(item.user_identifier)).email === 'gaoming@duiba.com.cn' && item.path.indexOf('/ad/addetail') >= 0) && !(JSON.parse(JSON.parse(item.user_identifier)).email === 'gaoming@duiba.com.cn' && item.path.indexOf('#/materialdata') >= 0) && !(JSON.parse(JSON.parse(item.user_identifier)).email === 'gaoming@duiba.com.cn' && item.path.indexOf('#/materialTestData') >= 0)
          })
          /**
           * 需要去重的原因是在快速切换路由的时候
           * 会有recordKey重复
           **/
          const uniqueList = this.unique(_list)
          this.tableData = uniqueList
          console.log(JSON.parse(uniqueList[0].user_identifier))
          // this.tableData = uniqueList.filter(v=>v.totalTracks>2);
        });
      }
    },
    computed: {
    },
    data() {
      return {
        page: 1,
        count: null,
        date: [
          new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 7),
          new Date()
        ],
        user: '',
        system: '',
        path: '',
        tableData: []
      };
    }
  };
</script>
<style lang="css" scoped>
.wrap {
  margin-top: 30px;
  padding: 0 20px;
}
.table {
  margin-top: 30px;
}
.user-input {
  width: 200px;
}
.over-path {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
}

</style>
